import { Box } from '@mui/material'
import { motion } from 'framer-motion'
import { t } from 'i18next'

import React from 'react'

interface Titre {
    titre: string,
    lien: string,
}

function TitrePage(props: Titre) {

    return (

        <Box className={"titrePage"}>
            <motion.div
            >
                <h2 className='texte_titre' >
                    {(t(props.titre)).toUpperCase()}
                    <hr style={{opacity: "50%"}} />
                    <center style={{fontSize: '100%', color: "rgba(255, 255, 255, .5)"}}>{t("Label.Accueil")+" / "+t(props.lien)}</center>
                </h2>
            </motion.div>
        </Box>
    )
}

export default TitrePage
